import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  // 5秒後に自動でトップページに戻る
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer); // クリーンアップ
  }, [navigate]);

  return (
    <div className="min-h-screen" style={{backgroundColor: '#fffbe0'}}>
      <div className="p-6 lg:p-12 ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">
          
          {/* 上部ロゴエリア */}
          <div className="text-center mb-12">
            <div style={{
              width: '120px',
              height: '120px',
              backgroundColor: 'white',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              boxShadow: '0 4px 12px rgba(139, 69, 19, 0.1)'
            }}>
              <img 
                src="/images/logo/logo.svg" 
                alt="立石農園ロゴ" 
                style={{width: '80px', height: '80px'}}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.style.background = 'linear-gradient(135deg, #ef4444, #f97316)';
                  e.target.nextElementSibling.style.display = 'block';
                }}
              />
              <span style={{
                color: 'white', 
                fontWeight: 'bold', 
                fontSize: '48px',
                display: 'none'
              }}>立</span>
            </div>
          </div>
          
          {/* 404エラーコンテンツ */}
          <div className="flex items-center justify-center min-h-64">
            <div className="text-center">
              
              {/* アイコン */}
              <div className="mb-8">
                <span className="text-6xl">🥒🍠</span>
              </div>
              
              {/* メインメッセージ */}
              <h1 className="text-3xl md:text-4xl font-bold mb-4" style={{color: '#8b4513'}}>
                お探しのページが見つかりません
              </h1>
              
              {/* 説明文 */}
              <p className="text-lg md:text-xl mb-8" style={{color: '#8b4513', opacity: 0.8}}>
                お探しのページは存在しないか、<br />
                URLが間違っています！
              </p>
              
              {/* 自動リダイレクト案内 */}
              <div className="mb-8">
                <p className="text-base mb-4" style={{color: '#8b4513', opacity: 0.7}}>
                  5秒後に自動でトップページに戻ります
                </p>
                
                {/* 手動ボタン */}
                <button
                  onClick={() => navigate('/')}
                  className="px-6 md:px-8 py-3 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all duration-300"
                  style={{
                    color: '#fff',
                    backgroundColor: '#ef4444',
                    border: '2px solid #ef4444',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#dc2626';
                    e.currentTarget.style.borderColor = '#dc2626';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#ef4444';
                    e.currentTarget.style.borderColor = '#ef4444';
                  }}
                >
                  今すぐトップページに戻る
                </button>
              </div>
              
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}